/* eslint-disable */
import  React from 'react'
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { isEmpty } from '../../utils/functions';
import ContentWrapper from "../../components/layout/ContentWrapper"
import { blue } from '../../utils/constants'
import { transferFunds, transferringFunds, adjustFunds, adjustingFunds } from '../../redux/actions/action_managefunds';
import SearchBar, { SearchBy } from './components/searchbar';
import Stats from './components/stats'
import SearchResults from './components/searchresults'
import Transfer from './components/transfer'
import Adjustment from './components/adjustment'

const formName = 'managefunds'

class Deposit extends React.Component {
   constructor(props)
   {
      super(props)
      this.state = {
            title: 'Manage Funds',
            showtransfer:false,
            showadjustment:false,            
            showSearchBar:true,
            showSearchResults:false,
            event:null
      }
      this.onHandleShowAdjustment = this.onHandleShowAdjustment.bind(this)
      this.onHandleShowTransfer = this.onHandleShowTransfer.bind(this)
      this.handleCancel = this.handleCancel.bind(this);
      this.handleTransferFunds = this.handleTransferFunds.bind(this);
      this.handleAdjustFunds = this.handleAdjustFunds.bind(this);
      this.handleSearch = this.handleSearch.bind(this);
   }

   componentWillReceiveProps = (nextProps)=> {
		if (nextProps.location.key !== this.props.location.key) 
		{
			this.setState(
			{
            showSearchBar:true,
            showadjustment:false,
            showtransfer:false,
            showSearchResults:false
			});
		}
  }

  handleSearch(){
     this.setState({
        showSearchResults:true
     })
  }

   onHandleShowAdjustment(event) {
      this.setState({ 
         showadjustment:true,
         showSearchBar:false,
         event
      })
   }

   onHandleShowTransfer(event) {
      this.setState({ 
         showtransfer:true,
         showSearchBar:false,
         event
      })
   }

   handleCancel(){
      this.setState({ 
         showtransfer:false,
         showadjustment:false,
         showSearchBar:true
      })
   }

   handleTransferFunds(event)
   {
      const { dispatch } = this.props;
      dispatch(transferringFunds());
      dispatch(transferFunds(event));
      this.setState({
         showtransfer:false,
         showSearchBar:true
      })
   }

   handleAdjustFunds(event)
   {
      const { dispatch } = this.props;
      dispatch(adjustingFunds());
      dispatch(adjustFunds(event));
      this.setState({
         showadjustment:false,
         showSearchBar:true
      })
   }

   render()
   {
      const { showtransfer, showadjustment, event, showSearchBar, showSearchResults } = this.state
      const { oidc, savingTransfer, savingAdjustment, searchResults, 
         eventDirector, totalAmountPaid, totalPaymentDue, totalBalance } = this.props;
         
      const showResults = showSearchResults && (searchResults !== undefined);      
      const  token =  isEmpty(oidc.user) === false ? oidc.user.access_token: '';

      return (  
      <ContentWrapper>
         <div className="content-heading">{this.state.title}</div>
         { showSearchBar && <span style={{ color: blue }}>Search event director by name, email or event name</span> }<br/>
         { showSearchBar &&
            <SearchBar 
               token={token}
               SearchByDefault={SearchBy.DirectorName}
               SearchByChange={this.onHandleSearchByChange}
               isEventSetup={false}
               onSearch={this.handleSearch}
            />
         }
         { showSearchBar && showResults && (searchResults.length > 0) &&
            <Stats 
               eventDirector={eventDirector}
               totalEvents={searchResults.length} 
               amountPaid={totalAmountPaid}
               paymentDue={totalPaymentDue} 
               balance={totalBalance}
            />
         }
         { showSearchBar && showResults &&
            <SearchResults 
            searchResults={searchResults} 
            showAdjustment={this.onHandleShowAdjustment} 
            showTransfer={this.onHandleShowTransfer} 
            />
         }
         { showtransfer && 
            <Transfer
            onCancel={this.handleCancel}
            searchResults={searchResults}
            event={event} 
            onSave={this.handleTransferFunds}
            saving={savingTransfer}            
            />
         }
         { showadjustment && 
            <Adjustment
            onCancel={this.handleCancel}
            event={event} 
            onSave={this.handleAdjustFunds}
            saving={savingAdjustment} 
            />
         }
      </ContentWrapper>
   )}
}

Deposit.propTypes = {
   oidc: PropTypes.object,
   dispatch: PropTypes.func,
   savingTransfer: PropTypes.bool,
   savingAdjustment: PropTypes.bool,
   searchResults: PropTypes.array,
   eventDirector: PropTypes.string,
   totalAmountPaid: PropTypes.number,
   totalPaymentDue: PropTypes.number,
   totalBalance: PropTypes.number
}

function mapStateToProps(state,ownProps){
   const formName          =  ownProps.form;
   const selector          = formValueSelector(formName);
   const savingTransfer    = selector(state, 'savingTransfer');
   const savingAdjustment  = selector(state, 'savingAdjustment');
   const searchResults     = selector(state, 'searchResults');
   const totalAmountPaid   = selector(state, 'totalAmountPaid');
   const totalPaymentDue   = selector(state, 'totalPaymentDue');
   const totalBalance      = selector(state, 'totalBalance');
   const eventDirector     = selector(state, 'eventDirector');
   return {
      savingTransfer,
      savingAdjustment,
      searchResults,
      totalAmountPaid,
      totalPaymentDue,
      totalBalance,
      eventDirector,
      oidc: { ...state.oidc }
   };
 }
 function mapDispatchToProps(dispatch){
   return bindActionCreators({
      transferFunds, 
      transferringFunds,
      adjustFunds,
      adjustingFunds
       },dispatch)
 }
 export default reduxForm({
   form:formName,
   destroyOnUnmount: false
 })(connect(mapStateToProps,mapDispatchToProps)(Deposit))


// WEBPACK FOOTER //
// ./src/containers/deposit/index.js